import ThemeData from './theme-data.json';
import { createTheme } from 'iiht-proctoring-ui-components/build/components/Styles';

const theme = createTheme(ThemeData);

export { theme };
